export enum FlexflowEmployeeStatuses {
  NOT_ENABLED = 'not_enabled',
  INVITED = 'enabled',
  ACTIVE = 'active',
  DISABLED = 'disabled',
  BLOCKED = 'blocked'
}

export enum FlexflowCardStatus {
  UNACTIVATED = 'unactivated',
  ACTIVE = 'active',
  SUSPENDED = 'suspended',
  TERMINATED = 'terminated'
}

export enum ActionButtonLabels {
  INVITE = 'invite',
  DISABLE = 'disable',
  ENABLE = 'enable'
}

export enum ActionButtonValues {
  INVITE = 'invited',
  NOT_INVITED = 'not_invited',
  DISABLE = 'disabled'
}
